import { useState, useMemo } from 'react';
import { Button } from 'uiKit/atoms/Button/Button';
import { observer } from 'mobx-react';

import subscription from './Subscription.module.scss';
import styles from '../Filters.module.scss';
import { useStores } from 'stores';
import { compareArrWithExtentions, compareWithFilterExtentions, objToArr } from '../../../../helpers/utils';
import { ParsedQuery } from 'query-string/base';
import { Paragraph } from 'uiKit/atoms/Typography/components/Paragraph';

interface SubscriptionProps {
  queryParams: ParsedQuery<string>;
}

const Subscription = ({ queryParams }: SubscriptionProps) => {
  const { lotStore } = useStores();

  const qpData = useMemo(() => objToArr(queryParams), [queryParams]);

  const [subscribedFilters, setSubscribedFilters] = useState<typeof qpData>([]);

  const isButtonDisabled = compareArrWithExtentions(
    compareWithFilterExtentions(qpData),
    compareWithFilterExtentions(subscribedFilters)
  );

  const save = () => {
    lotStore.sendSubscription(queryParams);
    setSubscribedFilters(qpData);
  };

  return (
    <div className={styles.bns3_search_checkbox_container}>
      <Button disabled={isButtonDisabled} size="medium" className={subscription.bns3_search_save_button} onClick={save}>
        <Paragraph className={styles.bns3_search_checkbox_text}>Save My Subscription</Paragraph>
      </Button>
    </div>
  );
};

Subscription.displayName = 'Subscription';

export default observer(Subscription);
